<template>
  <div class="login-container"
       :style="{ 'background-image': 'url(' + loginBgImage + ')' }">
    <div class="login-box">
      <el-form ref="loginForm"
               :model="form"
               label-width="80px"
               :rules="loginRules"
               class="login-form register-box"
               auto-complete="on"
               label-position="left">
        <el-form-item>
          <h2 class="title">
            Hello！
          </h2>
          <h3 class="title">
            {{ title || "AiBEE 盘古标注平台 注册 " }}
          </h3>
        </el-form-item>
        <el-form-item label="用户名"
                      prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="密码"
                      prop="password_hash">
          <el-input v-model="form.password_hash"
                    type="password"
                    autocomplete="new-password" />
        </el-form-item>
        <el-form-item label="邮箱"
                      prop="email">
          <el-input v-model="form.email" />
        </el-form-item>
        <el-form-item label="手机号"
                      prop="phone">
          <el-input v-model="form.phone" />
        </el-form-item>
        <el-form-item style="margin-top: 20px;">
          <el-button :loading="loading"
                     type="primary"
                     round
                     style="width:50%;"
                     @click.native.prevent="handleLogin">
            确 定
          </el-button>
          <span style="margin-left:15px;">
            已有账号？<a class="btn-register"
                    @click="toLogin">直接登录</a>
          </span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import systemConfig from '@/config';
import { addUserNoToken } from '@/api/admin';

export default {
  name: 'Login',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value && !/^[a-zA-Z0-9]+$/.test(value)) {
        callback(new Error('密码只能是大小写字母、数字、不含特殊字符'));
      } else {
        callback();
      }
    };
    return {
      form: {},
      loginRules: {
        name: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { max: 50, message: '1~50任意字符', trigger: 'blur' },
        ],
        password_hash: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            max: 18, min: 6, message: '密码长度6~18位', trigger: 'blur',
          },
          { validator: validatePass, trigger: 'blur' },
        ],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
      },
      title: systemConfig.title,
      loginBgImage: null,
      loading: false,
      pwdType: 'password',
      redirect: undefined,
      verify_image: null,
      base64Prefix: 'data:image/jpeg;base64,',
      ttt: false, // 临时，等多次密码错误接口修改后去除
    };
  },
  computed: {
    ...mapGetters(['theme']),
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    // eslint-disable-next-line
    this.loginBgImage = require(`../../assets/login-${this.theme}.png`);
  },
  methods: {
    toLogin() {
      this.$router.push({
        path: '/login',
      });
    },
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = '';
      } else {
        this.pwdType = 'password';
      }
    },
    handleLogin() {
      // eslint-disable-next-line consistent-return
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.form);
          params.auth_group_ids = [3];
          addUserNoToken(params).then((res) => {
            this.$message({
              message: '恭喜你，注册成功请登录！',
              type: 'success',
            });
            this.toLogin();
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.verify-code {
  img {
    margin-left: 20px;
    display: inline-block;
    vertical-align: middle;
    max-height: 50px;
  }
}
.btn-register {
  font-size: 14px;
  text-decoration: underline;

  &:hover {
    font-weight: 600;
  }
}
</style>
